import type { Analytics } from 'firebase/analytics';

/**
 * The Firebase Analytics instance, once consent has loaded it.
 *
 * Kept apart from src/firebase.ts on purpose: importing that file boots the
 * whole Firebase app, and the waitlist form (rendered by many tests) only
 * needs to know whether analytics is running. Null means it is not: no
 * consent yet, no measurement id in this build, or an unsupported browser.
 */
let instance: Analytics | null = null;
let waiting: Array<(analytics: Analytics) => void> = [];

export function setAnalyticsInstance(next: Analytics | null): void {
  instance = next;
  // Null means analytics is not running, so nothing queued for it can run.
  const ready = waiting;
  waiting = [];
  if (next) ready.forEach((run) => run(next));
}

export function getAnalyticsInstance(): Analytics | null {
  return instance;
}

/**
 * Runs `run` with the instance: now if it exists, otherwise once it is set.
 * Consent is granted before the instance is created asynchronously, so an
 * action in that gap waits here instead of being lost.
 */
export function whenAnalyticsReady(run: (analytics: Analytics) => void): void {
  if (instance) run(instance);
  else waiting.push(run);
}
